import { ConsentBenefitsList } from "./ConsentBenefitsList";
import { ConsentRadioInput } from "./ConsentRadioInput";

import styles from "../ConsentBlock.module.scss";

type Props = {
  name: string;
  agreeRadioLabel: string;
  rejectRadioLabel: string;
  shortHtml: string;
  longHtml?: string;
  showMoreBenefitsButtonLabel?: string;
  showLessBenefitsButtonLabel?: string;
  onRadioGroupChange: (value: string) => void;
  selectedValue: string;
};

export const ConsentRadioGroup = ({
  name,
  agreeRadioLabel,
  rejectRadioLabel,
  shortHtml,
  longHtml,
  showMoreBenefitsButtonLabel,
  showLessBenefitsButtonLabel,
  onRadioGroupChange,
  selectedValue,
}: Props) => (
  <fieldset role="radiogroup">
    <div className={styles.radioGroupGrid}>
      <ConsentRadioInput
        name={name}
        value={"true"}
        selectedValue={selectedValue}
        label={agreeRadioLabel}
        onChange={() => onRadioGroupChange("true")}
      />
      <ConsentBenefitsList
        shortHtml={shortHtml}
        longHtml={longHtml}
        showMoreBenefitsButtonLabel={showMoreBenefitsButtonLabel}
        showLessBenefitsButtonLabel={showLessBenefitsButtonLabel}
      />
      <ConsentRadioInput
        name={name}
        value={"false"}
        selectedValue={selectedValue}
        label={rejectRadioLabel}
        onChange={() => onRadioGroupChange("false")}
      />
    </div>
  </fieldset>
);
